import React from "react"
import dayjs from "dayjs"
import { OrderHistoryLogEntry } from "lib/types/generated/graphql-types"
import { ReactComponent as FailedIcon } from "images/icons/xmark-thick.svg"

import {
  Entry,
  EntryDate,
  EntryEvent,
  Icon,
  IconWrapper,
  Info,
  Message
} from "./ErrorMessageEntry.styled"

type Props = {
  entry: OrderHistoryLogEntry
}

const ErrorMessageEntry = ({ entry }: Props) => {
  const formatErrorMessage = (errorMessage: string) => {
    let cleanedMessage = errorMessage

    if (cleanedMessage.startsWith("Error ")) {
      cleanedMessage = cleanedMessage.substring(6)
    }

    const jsonMatch = cleanedMessage.match(/^'({.*?})'(.*)$/)
    if (jsonMatch) {
      const [, jsonString, additionalText] = jsonMatch
      try {
        const parsed = JSON.parse(jsonString)
        const formattedJson = JSON.stringify(parsed, null, 2)
        return additionalText.trim()
          ? `${formattedJson}\n\n${additionalText.trim()}`
          : formattedJson
      } catch {
        return cleanedMessage
      }
    }

    try {
      const parsed = JSON.parse(cleanedMessage)
      return JSON.stringify(parsed, null, 2)
    } catch {
      return cleanedMessage
    }
  }

  return (
    <>
      <Entry>
        <IconWrapper>
          <Icon>
            <FailedIcon />
          </Icon>
        </IconWrapper>
        <EntryEvent>
          <div>
            {entry.errorMessage ? (
              <Message>
                {entry?.message ?? entry.status}
                <EntryDate>{dayjs(entry.timestamp).format("YYYY-MM-DD: HH:mm")}</EntryDate>
              </Message>
            ) : (
              <Message>
                {entry?.message ?? entry.status}{" "}
                <EntryDate>{dayjs(entry.timestamp).format("YYYY-MM-DD: HH:mm")}</EntryDate>
              </Message>
            )}
            <Info>
              <b>Error message: </b>
              <pre style={{ margin: 0, whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
                {entry.errorMessage ? formatErrorMessage(entry.errorMessage) : "No error message"}
              </pre>
            </Info>
          </div>
        </EntryEvent>
      </Entry>
    </>
  )
}

export default ErrorMessageEntry
